<template>
  <div>
    <Modal v-model="showStatus" title="产品编辑" @on-ok="comProSpecs" @on-cancel="close" width="800" :loading="subLoading" :closable="false" :mask-closable="false">
      <div class="f-m-con">
        <Spin fix v-if="isShowPercent">
          <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
          <div>{{ ShowPercentMsg }}</div>
        </Spin>
        <Form :model="editData" :label-width="80" label-colon>
          <Form-item label="产品名称">
            <Input v-model="editData.goods_name" placeholder="产品名称"></Input>
          </Form-item>
          <Form-item label="批准文号">
            <Input v-model="editData.pass_no" placeholder="批准文号"></Input>
          </Form-item>
          <Form-item label="生产厂家">
            <Input v-model="editData.maker" placeholder="生产厂家"></Input>
          </Form-item>
          <Form-item label="规格单位">
            <div class="specs-unit-img" v-for="(item,index) in specsUnit" :key="index">
              <Row>
                <Col span="10">
                  <Input v-model="item.specs" placeholder="规格"></Input>
                </Col>
                <Col span="1"></Col>
                <Col span="3">
                  <Input v-model="item.unit" placeholder="单位"></Input>
                </Col>
                <Col span="1"></Col>
                <Col span="4">
                  <upload v-if="showStatus" action="upProImg" ref="uploadRef" :maxSize="20240" multiple :max-length="20" :isBeforeVerifiy="true" :formatArr="['gif','jpg','jpeg','bmp','png','GIF','JPG','JPEG','BMP','PNG']" :imgName="index" @upSuccess="upSuccess" @upProgress="upProgress">
                    <Button slot="btn_view" class="up-btn" type="primary" icon="ios-cloud-upload-outline">上传图片</Button>
                  </upload>
                </Col>
                <Col span="5">
                  <Button ghost type="error" @click="delSpecsUnit(index)" v-if="specsUnit.length > 1">删除</Button>
                  <Button ghost type="primary" @click="addSpecsUnit" style="margin-left: 5px;" v-if="index == (specsUnit.length - 1)">新增</Button>
                </Col>
              </Row>
              <div v-if="item.imgs.length > 0" class="imgs-m">
                <div class="item-img" v-for="(val,key) in item.imgs" :key="key">
                  <div class="img" v-viewer>
                    <img :src="domain + val.path" alt="">
                  </div>
                  <a href="javascript:;" @click="delImg(index,key)" class="del icon iconfont">&#xe6a5;</a>
                  <Checkbox v-model="val.ismain" :true-value="1" :false-value="0" @on-change="changeMainImg(index,key,$event)" size="small">主图</Checkbox>
                  <Checkbox v-model="val.status" :true-value="1" :false-value="0" size="small">已审核</Checkbox>
                </div>
              </div>
              <div v-else class="empty-img">
                暂无图片
              </div>
            </div>
          </Form-item>
          <Form-item label="审核状态">
            <Radio-group v-model="editData.status">
              <Radio :label="1">已审核</Radio>
              <Radio :label="0">未审核</Radio>
            </Radio-group>
          </Form-item>
        </Form>
      </div>
    </Modal>
  </div>
</template>
<script>
import upload from "@/components/upload";
export default {
  name: "editPro",
  components:{
    upload
  },
  data(){
    return {
      showStatus:false,
      specsUnit:[{id:0,specs:'',unit:'',imgs:[]}],
      editData:{
        id:0, goods_name:'',pass_no:'',maker:'',status:0
      },
      domain:this.ApiUrl,
      subLoading:true,
      isShowPercent:false,
      ShowPercentMsg:'加载中...'
    }
  },
  methods:{
    open(gid){
      this.showStatus = true;
      if(gid){
        this.isShowPercent = true;
        this.requestApi('/adm/editProInit', {gid:gid}).then((res)=>{
          if(res.status == 1){
            this.specsUnit = res.specsUnit;
            this.editData = res.proData;
          }
          this.$nextTick(()=>{
            this.isShowPercent = false;
          })
        })
      }else{
        this.specsUnit = [{id:0,specs:'',unit:'',imgs:[]}];
        this.editData = {id:0,goods_name:'',pass_no:'',maker:'',status:0};
      }
    },
    close(){
      this.showStatus = false;
    },
    addSpecsUnit(){
      this.specsUnit.push({id:0,specs:'',unit:'',imgs:[]})
    },
    delSpecsUnit(index){
      if(this.specsUnit.length <= 1) return false;
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认要删除吗？</p>',
        onOk: () => {
          this.specsUnit.splice(index,1);
        }
      });
    },
    delImg(index,key){
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认要删除吗？</p>',
        onOk: () => {
          this.specsUnit[index].imgs.splice(key,1);
          this.$refs.uploadRef[index].handleRemoveImg(key);
        }
      });
    },
    changeMainImg(index,key,v){
      let obj = this.specsUnit[index].imgs;
      if(v){
        for (let i = 0;i < obj.length;i++){
          if(i == key) obj[i].ismain = 1;
          else obj[i].ismain = 0;
        }
      }else obj[key].ismain = 0;
    },
    upProgress(res){
      if(res.percent == -1) this.isShowPercent = false;
      else{
        this.ShowPercentMsg = '上传中...';
        this.isShowPercent = true;
      }
    },
    upSuccess(res){
      this.specsUnit[res.img_name].imgs.push(res.response.imgVal)
    },
    comProSpecs(){
      if(this.isShowPercent) return;
      this.requestApi('/adm/comEditPro', {editData:this.editData,specsUnit:this.specsUnit}).then((res)=>{
        if(res.status == 1){
          this.$emit('comSuccess')
        }else{
          this.$Message.error(res.msg);
          this.subLoading = false;
          setTimeout(()=>{
            this.subLoading = true;
          },50)
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import "~@/assets/css/product/editPro";
</style>
